export const V1_MENU_LIST_ALL = '/v1/menu/list-all'
export const V1_MENU_CLIENT_KEY = '/v1/instance/redisson/menu/get-menu-by-group'